import React from "react";

// Inline vectors (Figma 895:68768 "+ Auth Screens") — dependency-free.

/** Brand logo mark (Figma dVjcVHPFbh2rbBi8kP10wV 1:1848), colored via currentColor. */
export const LogoIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 50.7692 32"
    fill="none"
    aria-hidden
  >
    <path
      d="M17.1311 0.686729C19.5279 0.682522 21.8607 1.92476 23.1452 4.14947L33.226 21.6098C35.1378 24.9211 34.0033 29.1554 30.692 31.0671C27.3808 32.9789 23.1465 31.8441 21.2347 28.5329L17.113 21.3938L12.9913 28.5329C11.0796 31.8441 6.84554 32.9788 3.5343 31.0671C0.223042 29.1554 -0.911411 24.9211 1.00034 21.6098L11.0809 4.14947C12.3653 1.92477 14.6982 0.682576 17.095 0.686729H17.1311Z"
      fill="currentColor"
    />
    <circle cx="43.231" cy="24.1537" r="7.53846" fill="currentColor" />
    <circle
      cx="43.231"
      cy="7.53846"
      r="6.53846"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" aria-hidden>
    <path
      d="M4.16667 15.8333L15.8333 4.16667M4.16667 4.16667L15.8333 15.8333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Eye glyph from the design (vuesax/outline/eye, Figma "24 / Icon-eye"). */
export const EyeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M12 16.33C9.61 16.33 7.67 14.39 7.67 12C7.67 9.61 9.61 7.67 12 7.67C14.39 7.67 16.33 9.61 16.33 12C16.33 14.39 14.39 16.33 12 16.33ZM12 9.17C10.44 9.17 9.17 10.44 9.17 12C9.17 13.56 10.44 14.83 12 14.83C13.56 14.83 14.83 13.56 14.83 12C14.83 10.44 13.56 9.17 12 9.17Z"
      fill="currentColor"
    />
    <path
      d="M12 21.02C8.24 21.02 4.69 18.82 2.25 15C1.19 13.35 1.19 10.66 2.25 9C4.7 5.18 8.25 2.98 12 2.98C15.75 2.98 19.3 5.18 21.74 9C22.8 10.65 22.8 13.34 21.74 15C19.3 18.82 15.75 21.02 12 21.02ZM12 4.48C8.77 4.48 5.68 6.42 3.52 9.81C2.77 10.98 2.77 13.02 3.52 14.19C5.68 17.58 8.77 19.52 12 19.52C15.23 19.52 18.32 17.58 20.48 14.19C21.23 13.02 21.23 10.98 20.48 9.81C18.32 6.42 15.23 4.48 12 4.48Z"
      fill="currentColor"
    />
  </svg>
);

/** Same eye with a slash — the "password revealed" toggle state. */
export const EyeOffIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M12 16.33C9.61 16.33 7.67 14.39 7.67 12C7.67 9.61 9.61 7.67 12 7.67C14.39 7.67 16.33 9.61 16.33 12C16.33 14.39 14.39 16.33 12 16.33ZM12 9.17C10.44 9.17 9.17 10.44 9.17 12C9.17 13.56 10.44 14.83 12 14.83C13.56 14.83 14.83 13.56 14.83 12C14.83 10.44 13.56 9.17 12 9.17Z"
      fill="currentColor"
    />
    <path
      d="M12 21.02C8.24 21.02 4.69 18.82 2.25 15C1.19 13.35 1.19 10.66 2.25 9C4.7 5.18 8.25 2.98 12 2.98C15.75 2.98 19.3 5.18 21.74 9C22.8 10.65 22.8 13.34 21.74 15C19.3 18.82 15.75 21.02 12 21.02ZM12 4.48C8.77 4.48 5.68 6.42 3.52 9.81C2.77 10.98 2.77 13.02 3.52 14.19C5.68 17.58 8.77 19.52 12 19.52C15.23 19.52 18.32 17.58 20.48 14.19C21.23 13.02 21.23 10.98 20.48 9.81C18.32 6.42 15.23 4.48 12 4.48Z"
      fill="currentColor"
    />
    <path
      d="M4 20L20 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

/** Filled circle-cross from the design (Figma "24 / Icon-Clear"). */
export const ClearIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" aria-hidden>
    <path
      d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.48599 3.24431C4.14984 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71761 10.009 2.03112 11.5851C2.34462 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.41489 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1209 7.84638 17.2635 5.78216 15.7407 4.25932C14.2178 2.73648 12.1536 1.87913 10 1.875ZM12.9453 12.0547C13.0627 12.1732 13.1285 12.3332 13.1285 12.5C13.1285 12.6668 13.0627 12.8268 12.9453 12.9453C12.8258 13.0608 12.6662 13.1254 12.5 13.1254C12.3338 13.1254 12.1742 13.0608 12.0547 12.9453L10 10.8828L7.94531 12.9453C7.82585 13.0608 7.66618 13.1254 7.5 13.1254C7.33382 13.1254 7.17415 13.0608 7.05469 12.9453C6.93732 12.8268 6.87148 12.6668 6.87148 12.5C6.87148 12.3332 6.93732 12.1732 7.05469 12.0547L9.11719 10L7.05469 7.94531C6.95502 7.82388 6.90409 7.66971 6.9118 7.51281C6.9195 7.3559 6.9853 7.20747 7.09638 7.09638C7.20747 6.9853 7.3559 6.9195 7.51281 6.9118C7.66971 6.90409 7.82388 6.95502 7.94531 7.05469L10 9.11719L12.0547 7.05469C12.1761 6.95502 12.3303 6.90409 12.4872 6.9118C12.6441 6.9195 12.7925 6.9853 12.9036 7.09638C13.0147 7.20747 13.0805 7.3559 13.0882 7.51281C13.0959 7.66971 13.045 7.82388 12.9453 7.94531L10.8828 10L12.9453 12.0547Z"
      fill="currentColor"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2071 8.29289C17.5976 8.68342 17.5976 9.31658 17.2071 9.70711L11.2071 15.7071C10.8166 16.0976 10.1834 16.0976 9.79289 15.7071L6.79289 12.7071C6.40237 12.3166 6.40237 11.6834 6.79289 11.2929C7.18342 10.9024 7.81658 10.9024 8.20711 11.2929L10.5 13.5858L15.7929 8.29289C16.1834 7.90237 16.8166 7.90237 17.2071 8.29289Z"
      fill="currentColor"
    />
  </svg>
);
